// extracted by mini-css-extract-plugin
module.exports = {"triggerButton":"CoverUpload_triggerButton__3__4h","triggerButtonActive":"CoverUpload_triggerButtonActive__3Nf1g"};